if (!Number.isFloat) {
  Number.isFloat = function (n) {
    return !isNaN(n) && parseFloat(n) % 1 !== 0;
  };
}